<template>
  <el-dialog
    :visible="visible"
    :title="$t('SeaExport.CabinCopy')"
    width="400px"
    custom-class="cabin-duplicate-dialog"
    top="5vh"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <el-form ref="form" :model="cabinForm" label-position="left" label-width="80px">
      <fieldset v-for="i in 5" :key="i">
        <legend>{{ $t('SeaExport.ShippingSpace') + i }}</legend>
        <el-form-item :label="$t('SeaExport.ShippingCompany')" :prop="`carrierId${i}`">
          <cargo-company-select
            no="1"
            :method-params="{companyLob:'seaExport',seaCmp:true,active:true}"
            :default-value="cabinForm[`carrierId${i}`]"
            @change="p=>{cabinForm[`carrierId${i}`]=p.value;}"
          />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.BookingAgent')" :prop="`bookingAgent${i}`">
          <cargo-advance-select
            no="2"
            :select-type="selectTypeNames.basic_data_Company"
            filterable
            :method-params="{bookingAgent:true,companyLob:'seaExport',active:true}"
            :default-value="cabinForm[`bookingAgent${i}`]"
            @parentCallBack="p=>{cabinForm[`bookingAgent${i}`]=p.value}"
          />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.DateOfDeparture')" :prop="`etd${i}`">
          <cargo-date-time-picker v-model="cabinForm[`etd${i}`]" no="3" style="width: 100%" value-format="yyyy-MM-dd" />
        </el-form-item>
      </fieldset>
    </el-form>
    <div slot="footer">
      <el-button no="4" type="primary" @click="handleSubmit">{{ $t('SeaExport.Confirm') }}</el-button>
      <el-button no="5" @click="handleClose">{{ $t('SeaExport.Cancel') }}</el-button>
    </div>
  </el-dialog>
</template>
<script>
import CargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import CargoDateTimePicker from '@/components/Cargo/Common/CargoDateTimePicker'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'

export default {
  name: 'CabinDuplicateDialog',
  components: { CargoDateTimePicker, CargoAdvanceSelect, CargoCompanySelect },
  props: {
    visible: {
      type: Boolean,
      default: () => false
    },
    job: {
      type: Object,
      default: () => ({})
    },
    reloadFunc: {
      type: Function,
      default: () => (null)
    }
  },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      cabinForm: {
        carrierId1: '',
        bookingAgent1: '',
        etd1: '',
        carrierId2: '',
        bookingAgent2: '',
        etd2: '',
        carrierId3: '',
        bookingAgent3: '',
        etd3: '',
        carrierId4: '',
        bookingAgent4: '',
        etd4: '',
        carrierId5: '',
        bookingAgent5: '',
        etd5: ''
      }
    }
  },
  methods: {
    handleSubmit() {
      // console.log('cabinDuplicate----result', this.cabinForm)
      const cabinForm = { ...this.cabinForm }
      if (cabinForm) {
        const cabinList = []
        for (let i = 1; i < 6; i++) {
          const carrierId = cabinForm['carrierId' + i]
          const bookingAgent = cabinForm['bookingAgent' + i]
          const dfSecondVesselETD = cabinForm['etd' + i]
          if (!carrierId && !bookingAgent && !dfSecondVesselETD) continue
          if (!carrierId) {
            this.$message.warning(this.$t('SeaExport.EnterShippingCompany', [i]))
            return
          }
          if (!bookingAgent) {
            this.$message.warning(this.$t('SeaExport.EnterBookingAgent', [i]))
            return
          }
          if (!dfSecondVesselETD) {
            this.$message.warning(this.$t('SeaExport.EnterEtd', [i]))
            return
          }
          const obj = {}
          obj.carrierId = carrierId
          obj.bookingAgent = bookingAgent
          obj.secondVesselETD = dfSecondVesselETD
          cabinList.push(obj)
        }
        if (!cabinList || cabinList.length === 0) {
          this.$message.warning(this.$t('SeaExport.CheckEnterShippingCompanyBookingAgentEtd'))
          return
        }
        this.$emit('submit', cabinList)
        this.handleClose()
      }
    },
    handleClose() {
      this.$refs.form.resetFields()
      this.$emit('close')
    },
    // 添加数据，并校验是否不全为空
    addList(carrierId, bookingAgent, dfSecondVesselETD, cabinList) {
      if (carrierId && parseInt(carrierId) > 0 && bookingAgent && parseInt(bookingAgent) > 0 && dfSecondVesselETD) {
        const obj = {}
        obj.carrierId = carrierId
        obj.bookingAgent = bookingAgent
        obj.secondVesselETD = dfSecondVesselETD
        cabinList.push(obj)
        return true
      }
      if ((!carrierId || parseInt(carrierId) === 0) && (!bookingAgent || parseInt(bookingAgent) === 0)) {
        return true
      }
      if (!dfSecondVesselETD) {
        this.$message.warning(this.$t('Message.DateOfDepartureCannotBeNull'))
        return false
      }
      this.$message.warning(this.$t('SeaExport.CheckShippingCompanyAndBookingAgent'))
      return false
    }
  }
}
</script>
<style lang="scss">
.cabin-duplicate-dialog {
  .el-dialog {
    &__header,&__body,&__footer{
      padding:10px 15px!important;
    }
    &__title{
      vertical-align: middle;
    }
    &__headerbtn{
      top:15px;
      right:15px;
    }
    &__body {
      fieldset {
        padding-bottom: 0;
        border-style: solid;
        border-color: #dfe4ed;
      }
    }
  }
}
</style>
